<template>
	<div class="">
		<v-col cols="12" sm="12" class="">
			<v-data-table
				v-if="hasItens"
				:headers="colunas"
				:items="itens"
				:server-items-length="totalItens"
				item-key="id"
				:options="paginacaoInterna"
				no-data-text="Não há anexos cadastrados"
				hide-default-footer
				class="arp-listview row-pointer"
			>
				<template #item.tipoDocumento="{ item }">
					<texto-tooltip :texto="item.tipoDocumento" :tamanho-maximo="50"></texto-tooltip>
				</template>
				<template #item.acoes="{ item }">
					<anexo-adesao-listagem-botoes-acoes
						:documento="item"
						@baixar-anexo="baixarAnexo"
						@excluir-anexo="excluirAnexo"
					></anexo-adesao-listagem-botoes-acoes>
				</template>
				<template #item.dataCadastro="{ item }">
					<span>{{ item.dataCadastro | formatDataHourMinuteFilter }}</span>
				</template>
			</v-data-table>

			<template-listagem-vazia :total-itens="totalItens" :textos="textos"></template-listagem-vazia>

			<paginacao-tabela
				v-if="totalItens > 1"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				@resetar-page="resetarPage"
			></paginacao-tabela>
		</v-col>
	</div>
</template>
<script>
import { Alert, TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import AnexoAdesaoListagemBotoesAcoes from '@/views/pages/adesao/publica/anexos/listar-anexos/botoes-acoes/AnexoAdesaoListagemBotoesAcoes.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'listagem-anexos-adesao-view',
	components: {
		TextoTooltip,
		PaginacaoTabela,
		TemplateListagemVazia,
		AnexoAdesaoListagemBotoesAcoes,
	},
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Título', 'titulo', '60%'),
				new TabelaColunaUtils('Tipo Documento', 'tipoDocumento', '20%'),
				new TabelaColunaUtils('Data inclusão', 'dataCadastro', '15%'),
				new TabelaColunaUtils('Ações', 'acoes', '5%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados documentos',
			},
			textoTamanhoMaximo: 80,
			alert: new Alert(this.$store),
		}
	},
	computed: {
		...mapState({
			idSolicitacaoAdesao: (state) => state.adesaoPublica.idSolicitacaoAdesao,
		}),
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ADESAO_PUBLICA.RESETAR_ANEXOS_LISTAGEM)
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		async baixarAnexo(anexo) {
			await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BAIXAR_ANEXO, anexo)
		},
		async excluirAnexo(anexo) {
			await this.$store
				.dispatch(actionTypes.ADESAO_PUBLICA.EXCLUIR_ANEXO, anexo)
				.then(() => this.alert.showSuccess(`Operação realizada com sucesso.`))
			await this.carregarAnexos()
		},
		async carregarAnexos() {
			const retorno = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_ANEXOS_POR_FILTRO)
			if (retorno) {
				return this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ANEXOS, retorno)
			}
		},
	},
}
</script>
<style scoped lang="stylus"></style>
